import Vue from "vue";
import VueRouter from "vue-router";

import PageNotFound from "../views/PageNotFound.vue";
import Home from "../views/Home.vue";
import Joulukalenteri from "../views/Kalenteri.vue";
import Aikataulu from "../views/Aikataulu.vue"

if ("scrollRestoration" in history) {
  history.scrollRestoration = "manual";
}

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/home",
    redirect: "/"
  },
  {
    path: "/kalenteri",
    redirect: "/joulukalenteri"
  },
  {
    path: "/joulukalenteri",
    name: "Joulukalenteri",
    component: Joulukalenteri
  },
  {
    path: "/aikataulu",
    name: "Aikataulu",
    component: Aikataulu
  },
  {
    path: "/tietoa",
    redirect: "/aikataulu"
  },
  {
    path: "*",
    name: "404",
    component: PageNotFound
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return new Promise(resolve => {
      const position = { x: 0, y: 0 };

      if (savedPosition) {
        position.x = savedPosition.x;
        position.y = savedPosition.y;
      }

      router.app.$root.$once("scrollBeforeEnter", () => {
        resolve(position);
      });
    });
  },
  routes
});

export default router;
